import getPlanAsURL from 'core/controllerPlans/getPlanAsURL'
import clickEventName from 'utils/DOM/clickEventName'
import toggleClass from 'utils/DOM/toggleClass'
import store from 'utils/store/withMiddleware'

function addPlanId() {
  this.href += getPlanAsURL(store.getState())
}

function registryListenersDOM() {
  $('body')
    .on(clickEventName, '.add-plan', addPlanId)
    .on(clickEventName, '.isc-add-plan', addPlanId)
    .on(clickEventName, '.plan-switch__skip', () =>
      toggleClass('.plan-switch__wrap', 'd-none', true)
    )
}

export default registryListenersDOM
